import { render } from "./EventAutocomplete.vue?vue&type=template&id=98384454&scoped=true"
import script from "./EventAutocomplete.vue?vue&type=script&lang=js"
export * from "./EventAutocomplete.vue?vue&type=script&lang=js"

import "./EventAutocomplete.vue?vue&type=style&index=0&id=98384454&scoped=true&lang=css"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98384454"]])

export default __exports__